export var FirstRunType;
(function (FirstRunType) {
    FirstRunType["CommercialItAdmin"] = "CommercialItAdmin";
    FirstRunType["CommercialStandardUser"] = "CommercialStandardUser";
    FirstRunType["ConsumerFree"] = "ConsumerFree";
    /**
     * Specifies that user should not be shown upsell content.
     */
    FirstRunType["ConsumerFreeUpsellDisabled"] = "ConsumerFreeUpsellDisabled";
    FirstRunType["ConsumerPaidFamily"] = "ConsumerPaidFamily";
    FirstRunType["ConsumerPaidIndividual"] = "ConsumerPaidIndividual";
    FirstRunType["EduFaculty"] = "EduFaculty";
    FirstRunType["EduItAdmin"] = "EduItAdmin";
    FirstRunType["EduStudent"] = "EduStudent";
})(FirstRunType || (FirstRunType = {}));
//# sourceMappingURL=FirstRunType.js.map